module.exports = __webpack_public_path__ + "img/curtain-left.ed0a89e4.png";